export const nodeId = "__adblock-extension-info";
export const datasetKey = "adblockExtensionInfo";
